<template>
  <div class="col-12">
    <div class="card shadow mb-4">
      <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
        <h6 class="m-0 font-weight-bold">{{ $t('Consumption') }} {{ $t('now') }}</h6>
      </div>
      <div class="card-body row">
        <div class="col-12 text-center"><LoadingSpinner v-if="loading"></LoadingSpinner></div>
        <div v-show="!loading" v-for="appliance in sorted_data" :key="appliance.id" class="mb-4 col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
          <div class="col-auto d-flex align-items-center"> 
            <img style="height: 40px" :src="get_appliance_icon(appliance.device.appliance.type)"> 
            <div class="ml-1">
              {{ $t(appliance.device.appliance.type) }} 
              ({{ appliance.device.appliance.brand ? appliance.device.appliance.brand.split(" ")[0] : $t('empty') }})
              <div class="h6 mb-0 ">
                <span class="text-orange font-weight-bold">{{ Math.round(appliance.current_data.consumption || 0) }}</span> W
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appliance_icons from '../helpers/appliance_icons.json'
import LoadingSpinner from './LoadingSpinner.vue'

export default  {
  name: 'AppliancesCurrentData',
  components: {
    LoadingSpinner,
  },
  methods: {
    get_appliance_icon: function(appliance) {
      return appliance_icons[appliance]
    }
  },
  computed: {
    current_lang: function(){
      return this.$i18n.locale
    },
    range: function(){
      return this.$store.getters.range
    },
    sorted_data: function(){
      if (!this.data.length) return []
      let data = [...this.data]
      //console.log(data)
      data.sort((a,b) => this.$i18n.t(a.device.appliance.type) > this.$i18n.t(b.device.appliance.type))
      return data
    },
    data: function(){
      return this.$store.getters.data
    },
    loading: function(){
      return this.$store.getters.data_loading
    }
  }
}
</script>

<style>
</style>
